export default function IconGreenCheckmark({
  width = "24",
  height = "24",
  fill = "#259b12",
  rotate = "0",
}) {
  return (
    <svg
      width={width}
      zoomAndPan="magnify"
      viewBox="0 0 224.87999 225"
      height={height}
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
      style={{ transform: `rotate(${rotate}deg)` }}
    >
      <defs>
        <clipPath id="d3ff183397">
          <path
            d="M 0 0.0585938 L 224.761719 0.0585938 L 224.761719 224.9375 L 0 224.9375 Z M 0 0.0585938 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="32d7afc570">
          <path
            d="M 0 2.183594 L 220.632812 2.183594 L 220.632812 222.535156 L 0 222.535156 Z M 0 2.183594 "
            clip-rule="nonzero"
          />
        </clipPath>
      </defs>
      <g clip-path="url(#d3ff183397)">
        <path
          fill="#ffffff"
          d="M 0 0.0585938 L 224.878906 0.0585938 L 224.878906 224.941406 L 0 224.941406 Z M 0 0.0585938 "
          fill-opacity="1"
          fill-rule="nonzero"
        />
        <path
          fill="#ffffff"
          d="M 0 0.0585938 L 224.878906 0.0585938 L 224.878906 224.941406 L 0 224.941406 Z M 0 0.0585938 "
          fill-opacity="1"
          fill-rule="nonzero"
        />
      </g>
      <path
        fill={fill}
        d="M 116.136719 172.769531 C 111.015625 178.457031 106.003906 184.117188 101.035156 189.789062 C 97.628906 185.96875 94.269531 182.203125 90.964844 178.496094 C 87.65625 174.820312 84.398438 171.210938 81.207031 167.667969 C 77.664062 163.917969 74.257812 160.320312 71.027344 156.902344 C 64.585938 150.054688 58.921875 143.859375 54.632812 138.300781 C 46.0625 127.183594 43 118.597656 50.226562 112.386719 C 57.457031 106.175781 65.496094 110.480469 75.226562 120.605469 C 80.09375 125.667969 85.378906 132.1875 91.199219 139.570312 C 94.097656 143.273438 97.15625 147.171875 100.335938 151.230469 C 100.40625 151.320312 100.601562 151.558594 100.570312 151.535156 L 100.582031 151.578125 L 100.609375 151.675781 L 100.675781 151.878906 C 100.722656 152.019531 100.785156 152.171875 100.859375 152.335938 C 101.007812 152.660156 101.203125 153.019531 101.429688 153.386719 C 101.757812 153.167969 102.160156 152.808594 102.542969 152.386719 C 104.011719 150.78125 105.609375 149.035156 107.316406 147.171875 C 109.773438 144.527344 112.382812 141.714844 115.117188 138.769531 C 120.605469 132.90625 126.632812 126.558594 132.9375 120 C 145.550781 106.878906 159.292969 92.902344 172.144531 80.222656 C 197.851562 54.863281 220 34.683594 222.441406 36.871094 C 224.878906 39.0625 207.148438 63.203125 184.636719 91.433594 C 173.382812 105.546875 160.933594 120.683594 149.214844 134.605469 C 143.355469 141.566406 137.679688 148.226562 132.425781 154.304688 C 129.785156 157.332031 127.265625 160.222656 124.890625 162.945312 C 121.765625 166.453125 118.832031 169.742188 116.136719 172.769531 "
        fill-opacity="1"
        fill-rule="nonzero"
      />
      <g clip-path="url(#32d7afc570)">
        <path
          fill={fill}
          d="M 210.027344 65.171875 C 207.128906 68.863281 204.136719 72.644531 201.074219 76.488281 C 200.125 77.675781 199.167969 78.871094 198.210938 80.070312 C 201.929688 90.136719 203.964844 101.015625 203.964844 112.359375 C 203.964844 163.933594 161.953125 205.890625 110.316406 205.890625 C 58.675781 205.890625 16.667969 163.933594 16.667969 112.359375 C 16.667969 60.789062 58.675781 18.832031 110.316406 18.832031 C 142.601562 18.832031 171.121094 35.234375 187.964844 60.128906 C 192.109375 56.054688 196.167969 52.101562 200.097656 48.3125 C 196.578125 43.40625 192.648438 38.777344 188.320312 34.457031 C 178.191406 24.339844 166.394531 16.394531 153.257812 10.847656 C 139.652344 5.101562 125.203125 2.1875 110.316406 2.1875 C 95.425781 2.1875 80.976562 5.101562 67.371094 10.847656 C 54.234375 16.394531 42.4375 24.339844 32.308594 34.457031 C 22.183594 44.570312 14.230469 56.351562 8.671875 69.472656 C 2.917969 83.058594 0 97.492188 0 112.359375 C 0 127.230469 2.917969 141.660156 8.671875 155.246094 C 14.230469 168.367188 22.183594 180.148438 32.308594 190.265625 C 42.4375 200.378906 54.234375 208.324219 67.371094 213.875 C 80.976562 219.621094 95.425781 222.535156 110.316406 222.535156 C 125.203125 222.535156 139.652344 219.621094 153.257812 213.875 C 166.394531 208.324219 178.191406 200.378906 188.320312 190.265625 C 198.449219 180.148438 206.402344 168.367188 211.957031 155.246094 C 217.710938 141.660156 220.628906 127.230469 220.628906 112.359375 C 220.628906 97.492188 217.710938 83.058594 211.957031 69.472656 C 211.34375 68.023438 210.699219 66.589844 210.027344 65.171875 "
          fill-opacity="1"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  );
}
